var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('headerCustom',{attrs:{"menuActive":true}}),_c('banner'),_c('dream'),_c('methodology'),_c('benefits'),_c('testimonials'),_c('start'),_c('plans'),_c('about'),_c('questions'),_c('footerCustom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }